// This slice tracks file uploads. When a file is uploaded we—including those validated
// by the accepted upload-schema (see src/lib/validation/input/upload-schema.ts)—can update state accordingly.

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UploadFile {
  id: string
  fileName: string
  progress: number
  status: 'pending' | 'uploading' | 'success' | 'error'
}

interface UploadsState {
  files: UploadFile[]
}

const initialState: UploadsState = {
  files: [],
}

export const uploadsSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    addUpload: (state, action: PayloadAction<UploadFile>) => {
      state.files.push(action.payload)
    },
    updateUpload: (state, action: PayloadAction<UploadFile>) => {
      const index = state.files.findIndex(file => file.id === action.payload.id)
      if (index !== -1) {
        state.files[index] = action.payload
      }
    },
    removeUpload: (state, action: PayloadAction<string>) => {
      state.files = state.files.filter(file => file.id !== action.payload)
    },
    clearUploads: (state) => {
      state.files = []
    },
  },
})

export const { addUpload, updateUpload, removeUpload, clearUploads } = uploadsSlice.actions

export default uploadsSlice.reducer
